<div
  *ngIf="status"
  class="cg-flex-vertical-center"
  [class.cg-font-size-m]="size === 'medium'"
  [class.cg-font-size-ml]="size === 'large'"
>
  <div class="cg-margin-right-sm">
    <cigna-icon
      *ngIf="!inactive && parseCoverageStatus(status) !== ''"
      [class.cg-icon-sm]="size === 'small'"
      [class.cg-icon-md]="size === 'medium'"
      [class.cg-icon-lg]="size === 'large'"
      class="cg-color-success"
      type="checkmark-circle-outline"
    ></cigna-icon>
    <cigna-icon
      *ngIf="inactive && parseCoverageStatus(status) !== ''"
      [class.cg-icon-sm]="size === 'small'"
      [class.cg-icon-md]="size === 'medium'"
      [class.cg-icon-lg]="size === 'large'"
      class="cg-color-severe-warn"
      type="exclamation-circle"
    ></cigna-icon>
  </div>

  <ng-container *ngIf="status">
    <ng-container [ngSwitch]="parseCoverageStatus(status)">
      <div *ngSwitchCase="'Active'">Covered</div>
      <div *ngSwitchCase="'Inactive'">Not Covered</div>
      <div *ngSwitchCase="''"></div>
      <div *ngSwitchDefault>
        {{ status }}
      </div>
    </ng-container>
  </ng-container>
</div>
